import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { wsURL } from "../services/axiosConfig";
import { updateJoinPotSoket } from "../Pages/Dashboard/dashboard.slice";
import { updateRoundToJoinSocket } from "../Pages/RoundToJoin/roundToJoin.slice";
import { updateLiveFixtureSocket } from "../Pages/PickDetail/pickDetail.slice";
import {
  updateFixtureAndResultHomeDetails,
  updateFixtureAndResultHomeSocket,
} from "../Components/fixturesAndResult.slice";

const useWebSocket = (path) => {
  const dispatch = useDispatch();

  const socketRef = useRef(null);


  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const protocol = window.location.protocol === "https:" ? "wss" : "wss";
    const socketUrl = `${protocol}://${wsURL}${path}`;
    const socket = new WebSocket(socketUrl);
    socketRef.current = socket;

    // setInterval(() => {
    //   let count = 0;
    //   console.log("WebSocket is alive");

    //   dispatch(
    //     updateFixtureAndResultHomeDetails({
    //       awayteam_goal: count++,
    //       fixture_id: "1378978",
    //       hometeam_goal: count + 2,
    //       status: "live",
    //     })
    //   );
    // }, 10000);

    // setInterval(() => {
    //   dispatch(
    //     updateLiveFixtureSocket({
    //       awayteam_goal: 9,
    //       fixture_id: "1379014",
    //       hometeam_goal: 5,
    //       status: "1H",
    //     })
    //   );
    // }, 3000);

    socket.onopen = () => {
      console.log("WebSocket connection opened");
    };

    socket.onmessage = (event) => {
      try {
        const res = JSON.parse(event?.data);
        if (path === "/ws/joinpot/pot/") {
          if (
            res.data?.message !== "Live Update from HTTP trigger" &&
            res.data?.message === "Updated"
          ) {
            if (res?.data?.fields) {
              dispatch(updateJoinPotSoket(res.data.fields));
              dispatch(updateRoundToJoinSocket(res.data.fields));
            }
          }
        } else {
          if (path === "/ws/livefixture/") {
            if (
              res.data?.message === "Connection established" ||
              res?.data?.message === "Live Update from HTTP trigger" ||
              res?.data?.message === "Live Update - Updated"
            ) {
              if (res?.data?.fields) {
                dispatch(updateLiveFixtureSocket(res.data.fields));
                dispatch(updateFixtureAndResultHomeDetails(res.data.fields));
                dispatch(updateFixtureAndResultHomeSocket(res.data.fields));
              }
            }
          }
        }
      } catch (err) {
        console.error("Invalid WebSocket message", err);
      }
    };

    socket.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    return () => {
      if (
        socket.readyState === WebSocket.OPEN ||
        socket.readyState === WebSocket.CONNECTING
      ) {
        socket.close();
      }
    };
  }, []);

  return socketRef;
};

export default useWebSocket;
